import React from "react";
import { useNavigate, useLocation } from "react-router";
import { toast } from "sonner";
import { Post } from "../../config/api/post";
import { AUTH } from "../../config/constants";
import { AuthPage, LoginForm } from "../../components/login-form";

function ForgetPassword3() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!state?.email || !state?.code) {
      navigate("/forgot-password", { replace: true });
    }
  }, [state, navigate]);

  const onSubmit = (values) => {
    if (values.password !== values.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    if ((values.password || "").length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }

    setLoading(true);

    Post(AUTH.resetPassword, {
      password: values.password,
      confirmPassword: values.confirmPassword,
      email: state.email,
      code: state.code,
    })
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          toast.success(response?.data?.message || "Password reset successfully");
          navigate("/signin", { replace: true });
        } else {
          toast.error(
            response?.data?.message || response?.response?.data?.message || "Reset failed"
          );
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.data?.message || e?.message || "Internal server error");
      });
  };

  return (
    <AuthPage>
      <LoginForm
        title="Set a new password"
        description="Use 8+ characters with uppercase, lowercase, a number, and a symbol"
        submitLabel="Save password"
        loading={loading}
        onSubmit={onSubmit}
        fields={[
          {
            name: "password",
            label: "New password",
            type: "password",
            placeholder: "Enter new password",
            minLength: 8,
            autoComplete: "new-password",
          },
          {
            name: "confirmPassword",
            label: "Confirm password",
            type: "password",
            placeholder: "Confirm password",
            minLength: 8,
            autoComplete: "new-password",
          },
        ]}
        footer={
          <button
            type="button"
            className="text-center text-sm font-medium underline-offset-2 hover:underline"
            onClick={() => navigate("/signin")}
          >
            Back to login
          </button>
        }
      />
    </AuthPage>
  );
}

export default ForgetPassword3;
